import { render, staticRenderFns } from "./StatusIcon.vue?vue&type=template&id=e8c01064&scoped=true"
import script from "./StatusIcon.vue?vue&type=script&lang=js"
export * from "./StatusIcon.vue?vue&type=script&lang=js"
import style0 from "./StatusIcon.vue?vue&type=style&index=0&id=e8c01064&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c01064",
  null
  
)

export default component.exports